import { IManagedScale, IPayScaleQualification } from '../types';

export function ensureRatesExist(scales: IManagedScale[]): IManagedScale[] {
    return scales.map((scale: IManagedScale, index: number) => {
        if (!scale.rate) {
            scale.rate = index;
        }

        return scale;
    });
}

export function filterQualificationsToCopyFromInitialScale(
    initialScale: IManagedScale,
    scales: IManagedScale[],
    educationQualificationNames: string[],
) {
    function matchesQualification(
        thisQualification: IPayScaleQualification,
        otherQualification: IPayScaleQualification,
    ) {
        return (
            otherQualification.qualification_id === thisQualification.qualification_id ||
            (educationQualificationNames.includes(otherQualification.name) &&
                educationQualificationNames.includes(thisQualification.name))
        );
    }

    function hasQualificationInPayScale(thisQualification: IPayScaleQualification, otherScale: IManagedScale) {
        return otherScale.qualifications.some((otherQualification) =>
            matchesQualification(thisQualification, otherQualification),
        );
    }

    return initialScale.qualifications.filter(
        (thisQualification) =>
            !scales.some(
                (otherScale) =>
                    initialScale.id !== otherScale.id && hasQualificationInPayScale(thisQualification, otherScale),
            ),
    );
}

export function deduplicateQualifications(qualifications: IPayScaleQualification[]): IPayScaleQualification[] {
    return qualifications.filter(
        (qualification, index, self) =>
            index === self.findIndex((t) => t.qualification_id === qualification.qualification_id),
    );
}

export function updateScales(
    scale: IManagedScale,
    scales: IManagedScale[],
    setScales: (scales: IManagedScale[]) => void,
    setInitialScale: (scale: IManagedScale) => void,
): IManagedScale[] {
    const updatedScales: IManagedScale[] = scales;

    const index = updatedScales.findIndex((x: IManagedScale) => x.id === scale.id);
    index === -1 ? updatedScales.push(scale) : (updatedScales[`${index}`] = scale);

    setScales(updatedScales);
    setInitialScale(updatedScales[0]);

    return updatedScales;
}

export function deleteScale(
    scaleId: string,
    scales: IManagedScale[],
    setScales: (scales: IManagedScale[]) => void,
    setInitialScale: (scale: IManagedScale) => void,
): IManagedScale[] {
    const updatedScales = scales.filter((x: IManagedScale) => x.id !== scaleId);

    setScales(updatedScales);
    setInitialScale(updatedScales[0]);

    return updatedScales;
}
